import styled from "styled-components";
import images from "../images";
import { DESKTOP_MEDIA_QUERY } from "../constants";

export const Wrapper = styled.div``;

export const Title = styled.div`
  margin: 23px;
  font-size: 16px;
  font-weight: 600;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 48px;
  }
`;

export const SummaryBlock = styled.div`
  width: 261px;
  height: 352px;
  margin: 0 auto 30px;
  padding: 62px 24px;
  background-image: url(${images.summary.src});
  background-size: cover;

  ${DESKTOP_MEDIA_QUERY} {
    width: 750px;
    height: 504px;
    padding: 0;
    background-image: url(${images.summary_d.src});
    position: relative;
  }
`;

export const Pic = styled.div`
  display: none;
  width: 150px;
  height: 198px;
  margin-bottom: 20px;
  background-image: url(${({ id }) => images[`dossier_character_${id}`].src});
  background-size: cover;
  background-position: center;
  border: 2px solid #0000ff;

  ${DESKTOP_MEDIA_QUERY} {
    display: block;
  }
`;

export const DossierBlock = styled.div`
  ${DESKTOP_MEDIA_QUERY} {
    position: absolute;
    top: 131px;
    left: 60px;
  }
`;

export const TopicBlock = styled.div`
  ${DESKTOP_MEDIA_QUERY} {
    width: 285px;
    position: absolute;
    bottom: 80px;
    right: 52px;
  }
`;

export const BlackText = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const RedText = styled.div`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #ff0000;

  ${DESKTOP_MEDIA_QUERY} {
    margin-bottom: 0px;
    font-size: 24px;
  }
`;
